module.exports = __webpack_public_path__ + "img/penlink-logo-white.e5159d65.png";